// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Image-module--placeholder--1qlT0"};